const FontFaceObserver = require('fontfaceobserver');

const fontsData = {
  'Roobert': { weight: 'normal' },
  'Nitti PX': { weight: 'normal' },
  'NeuroX': { weight: 'normal' }
};

const defaultFonts = [
  'Roobert',
	'Nitti PX',
	'NeuroX'
]

function loadFonts(fonts = defaultFonts) {
  return new Promise((resolve) => {
    const fontFaceObersvers = fonts.map(font => {
      const data = fontsData[font];
      return new FontFaceObserver(font, data);
    })
    Promise.all(fontFaceObersvers).then(() => {
      resolve();
    });
  })
}

export default loadFonts;